import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

//全局变量
const state = {
  //用户视频全局变量
  userInfo: {},   //当前登陆用户的信息
  roleList:[],   //角色集合
  permList:[],   //权限集合
  
  informChange:false,//个人信息变动
  examFile:[],//检查文件变动
  navbarPosition: 'left',//导航位置
  imageFlag:false,//影像序列加载完成->true->渲染影像->false
  deleteImage:-1,//要删除的影像

  goEasy:null,//推送对象
  apply:null,//申请端
  diag:null,//诊断端
  audit:null,//审核端

  addRouter:0,
  seriesList:[]
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js